import {
  AllegatoTipo,
  DocumentoTipo,
  MetodoPagamento,
  ModalitaRitiroConsegna,
  OffertaStato,
  PagamentoStato,
  RichiestaStato,
  RichiestaTipo,
  createAllegatoModel,
  createCriteriInvioModel,
  createDocumentoModel,
  createOffertaModel,
  createPagamentoModel,
  createProdottoRichiestoModel,
  createRichiestaModel,
  createServizioRichiestoModel,
  createTrackingStepModel,
  toRichiestaEntityList,
} from "../../domain/richieste";

const prodotto1 = createProdottoRichiestoModel({
  id: "prd_001",
  nome: "Tachipirina 1000",
  quantita: 2,
});

const prodotto2 = createProdottoRichiestoModel({
  id: "prd_002",
  nome: "Aspirina C",
  quantita: 1,
  formatoDiversoConsentito: true,
  nota: "Preferenza bustine",
});

const allegatoRicetta1 = createAllegatoModel({
  id: "all_001",
  tipo: AllegatoTipo.RICETTA,
  nomeFile: "ricetta-febbraio.pdf",
  url: "/mock/files/ricetta-febbraio.pdf",
});

const offerta1 = createOffertaModel({
  id: "off_001",
  sellerId: "ph_001",
  sellerName: "Seller Centrale",
  prezzoTotale: 24.5,
  distanzaKm: 1.2,
  tempoStimatoMin: 45,
  stato: OffertaStato.INVIATA,
  createdAt: "2026-02-25T10:55:00.000Z",
  voci: [
    { descrizione: "Tachipirina 1000", prezzo: 9.5, quantita: 2 },
    { descrizione: "Aspirina C", prezzo: 5.5, quantita: 1 },
  ],
});

const offerta2 = createOffertaModel({
  id: "off_002",
  sellerId: "ph_002",
  sellerName: "Seller San Marco",
  prezzoTotale: 23.9,
  distanzaKm: 2.4,
  tempoStimatoMin: 60,
  stato: OffertaStato.INVIATA,
  createdAt: "2026-02-25T11:10:00.000Z",
  voci: [
    { descrizione: "Tachipirina 1000", prezzo: 9.2, quantita: 2 },
    { descrizione: "Aspirina C", prezzo: 5.5, quantita: 1 },
  ],
});

const pagamentoNonAvviato = createPagamentoModel({
  stato: PagamentoStato.NON_AVVIATO,
});

const trackingInviata1 = createTrackingStepModel({
  stato: RichiestaStato.INVIATA,
  timestamp: "2026-02-25T10:20:00.000Z",
});

const richiesta1 = createRichiestaModel({
  id: "req_001",
  codice: "R-2026-0001",
  tipo: RichiestaTipo.PRODOTTI,
  titolo: "Richiesta farmaci cronici",
  stato: RichiestaStato.OFFERTE_RICEVUTE,
  utenteId: "usr_001",
  createdAt: "2026-02-25T10:20:00.000Z",
  updatedAt: "2026-02-25T11:10:00.000Z",
  unreadOffersCount: 2,
  noteUtente: "Consegna preferita nel pomeriggio.",
  criteriInvio: createCriteriInvioModel({
    modalita: ModalitaRitiroConsegna.CONSEGNA,
    raggioKm: 8,
  }),
  prodotti: [prodotto1, prodotto2],
  servizio: null,
  allegati: [allegatoRicetta1],
  offerte: [offerta1, offerta2],
  pagamento: pagamentoNonAvviato,
  tracking: [trackingInviata1],
  documenti: [],
});

const servizioGlicemia = createServizioRichiestoModel({
  codice: "SRV_GLICEMIA",
  nome: "Misurazione Glicemia",
  note: "Richiesta anche consegna referto",
});

const offertaServizio1 = createOffertaModel({
  id: "off_010",
  sellerId: "ph_003",
  sellerName: "Seller Duomo",
  prezzoTotale: 12,
  distanzaKm: 0.8,
  tempoStimatoMin: 20,
  stato: OffertaStato.ACCETTATA,
  letta: true,
  createdAt: "2026-02-24T08:45:00.000Z",
  voci: [{ descrizione: "Misurazione Glicemia", prezzo: 12, quantita: 1 }],
});

const pagamentoCardPagato = createPagamentoModel({
  stato: PagamentoStato.PAGATO,
  metodo: MetodoPagamento.CARD,
  transactionId: "trx_789",
  totale: 12,
});

const tracking2 = [
  createTrackingStepModel({ stato: RichiestaStato.INVIATA, timestamp: "2026-02-24T08:15:00.000Z" }),
  createTrackingStepModel({ stato: RichiestaStato.OFFERTA_ACCETTATA, timestamp: "2026-02-24T08:55:00.000Z" }),
  createTrackingStepModel({ stato: RichiestaStato.PAGATA, timestamp: "2026-02-24T09:00:00.000Z" }),
];

const documentoReferto1 = createDocumentoModel({
  id: "doc_001",
  tipo: DocumentoTipo.REFERTO,
  nomeFile: "referto-glicemia.pdf",
  url: "/mock/files/referto-glicemia.pdf",
  createdAt: "2026-02-24T11:30:00.000Z",
});

const richiesta2 = createRichiestaModel({
  id: "req_002",
  codice: "R-2026-0002",
  tipo: RichiestaTipo.SERVIZIO,
  titolo: "Misurazione glicemia",
  stato: RichiestaStato.PAGATA,
  utenteId: "usr_001",
  selectedSellerId: "ph_003",
  createdAt: "2026-02-24T08:15:00.000Z",
  updatedAt: "2026-02-24T09:00:00.000Z",
  noteUtente: "Disponibile dopo le 17:30",
  criteriInvio: createCriteriInvioModel({
    modalita: ModalitaRitiroConsegna.RITIRO,
    raggioKm: 5,
    selectedSellerIds: ["ph_003", "ph_004"],
  }),
  prodotti: [],
  servizio: servizioGlicemia,
  allegati: [],
  offerte: [offertaServizio1],
  pagamento: pagamentoCardPagato,
  tracking: tracking2,
  documenti: [documentoReferto1],
});

const richiesteRawMock = [richiesta1, richiesta2];

export const richiesteMock = toRichiestaEntityList(richiesteRawMock);


